import { render, staticRenderFns } from "./MatterTypeHistoryList.vue?vue&type=template&id=5727df70&"
import script from "./MatterTypeHistoryList.vue?vue&type=script&lang=js&"
export * from "./MatterTypeHistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports